import { apiAuthClient } from 'api/helpers';

import type {
  PostOrganisationRequestType,
  PostOrganisationResponseType,
} from '../types';

export const postOrganisation = async ({
  body,
}: PostOrganisationRequestType) => {
  const url = `/api/v2/organisations`;

  const { data } = await apiAuthClient.post<PostOrganisationResponseType>(
    url,
    body,
  );

  return data.data;
};
